var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.00390625)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 5.5127L25.2132 8.64869V27.4647L6.78125 21.6407V5.5127Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1894 7.01098C24.3638 7.2721 23.5369 7.53194 22.7139 7.79306L6.80859 3.01098C7.74043 2.73962 8.66971 2.4657 9.60155 2.19434C14.7984 3.79946 19.9952 5.40586 25.1894 7.01098Z",
    fill: "#FDB86D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1904 7.01074V28.237L22.7148 29.6987V7.79282L25.1904 7.01074Z",
    fill: "#FB861B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80859 3.01172V24.1637L22.7139 29.6997V7.7938C17.4108 6.2002 12.1116 4.60404 6.80859 3.01172ZM8.77595 21.8943V19.429C9.11259 19.5532 11.1363 20.1868 13.4083 20.8972L13.4275 23.3624C11.1452 22.6546 9.10875 22.0184 8.77595 21.8943ZM20.438 19.8591C19.656 19.5698 9.55803 16.4773 8.77595 16.1868V13.7215C9.57083 14.021 19.6803 17.1224 20.47 17.4181C20.4598 18.2322 20.4483 19.045 20.438 19.8591ZM20.438 16.508C19.656 16.2175 9.55803 13.1263 8.77595 12.8357V10.3692C9.57083 10.6687 19.6803 13.7701 20.47 14.0658C20.4598 14.8799 20.4483 15.6927 20.438 16.5068V16.508ZM20.438 13.3567C19.656 13.0661 9.55803 9.97492 8.77595 9.68436V7.21908C9.57083 7.51476 19.6803 10.62 20.47 10.9157C20.4598 11.7298 20.4483 12.5426 20.438 13.3567Z",
    fill: "#FBA03D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6c484347648d16f3d06c41f0b654624b.svg";
export { ForwardRef as ReactComponent };